module.exports = __webpack_public_path__ + "assets/img/title-98bd6fe1.png";